// import HomePage from "../../components/homePage/home-page.component";

// const Home = () => {

//   return (
//     <div>
//       <HomePage />
//     </div>
//   );
// };

// export default Home;
import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FaUserFriends } from "react-icons/fa";
import {
  IoChevronDown,
  IoChevronBack,
  IoChevronForward,
  IoAlertCircle,
  IoChatbubbles,
  IoHelpCircle,
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoSettingsSharp,
} from "react-icons/io5";
import "./home.styles.css"; // All styles for this component will be here

// Import images (ensure these paths are correct relative to Home.jsx)
import heroImageDesktop from "../../assets/hero.png";
import heroImageMobile from "../../assets/hero_mobile.png";
import royalCaninLogo from "../../assets/royal_canin_logo.png";
import purinaLogo from "../../assets/purina_logo.png";
import fashionImg from "../../assets/fashion.png";
import beautyImg from "../../assets/make_up.png";
import healthImg from "../../assets/health.png";
import petImg from "../../assets/pet.png";
import dinningOutImg from "../../assets/dinning_out.png";
import homeImg from "../../assets/home.png";
import travelImg from "../../assets/travel.png";
import marketplaceGIF from "../../assets/marketplace.gif";
import socialGIF from "../../assets/social.gif";
import eventsGIF from "../../assets/events.gif";
import businessGIF from "../../assets/business.gif";
import about_us from "../../assets/about-us.png";
import about_us_logo from "../../assets/about-us-logo.svg";
import about_us_background from "../../assets/about-us-background.png";
import testimonials from "../../assets/testimonials.png";
import userPic1 from "../../assets/user_1.png";
import userPic2 from "../../assets/user_2.png";
import userPic3 from "../../assets/user_3.png";

import faq from "../../assets/faq.png";
import features from "../../assets/features.png";
import { netural400, neturalBlack, primaryOrange } from "../../utils/colors";
import Collapsible from "react-collapsible";
import CustomLabel from "../../components/shared/label/custom-label.component";
import { faqData } from "../../utils/constants";
import AppDownloadSection from "../../components/home-page-footer/new-footer.component";
import { MdLocalOffer, MdWork } from "react-icons/md";
import { HiMiniTicket } from "react-icons/hi2";
import { isAndroid, isIOS } from "react-device-detect";

const categories = [
  { name: "Fashion", image: fashionImg },
  { name: "Beauty", image: beautyImg },
  { name: "Health", image: healthImg },
  { name: "Pets", image: petImg },
  { name: "DinningOut", image: dinningOutImg },
  { name: "Home", image: homeImg },
  { name: "Travel", image: travelImg },
];

const sections = [
  {
    title: "Save on products/services at discounted prices!",
    body: "Shop smarter with exclusive deals on everyday essentials and trusted providers.",
    icon: (isActive) => (
      <MdLocalOffer
        size={18}
        color={isActive ? primaryOrange : neturalBlack} // example inactive color
        style={{ transform: "scaleX(-1)" }}
      />
    ),
    gif: marketplaceGIF,
  },
  {
    title: "Connect with others, share, and explore together",
    body: "Post, follow interests, and connect with others through built-in social features.",
    icon: (isActive) => (
      <IoChatbubbles
        size={18}
        color={isActive ? primaryOrange : neturalBlack}
      />
    ),
    gif: socialGIF,
  },
  {
    title: "Find events that match your vibe",
    body: "Plan, join, and discover events that match your vibe – from community gatherings to group hangouts.",
    icon: (isActive) => (
      <HiMiniTicket size={18} color={isActive ? primaryOrange : neturalBlack} />
    ),
    gif: eventsGIF,
  },
  {
    title: "Start your store in minutes with no commission fee!",
    body: "List products or services. No hidden costs. Sell freely and focus on what matters—your business.",
    icon: (isActive) => (
      <MdWork size={18} color={isActive ? primaryOrange : neturalBlack} />
    ),
    gif: businessGIF,
  },
];

const testimonials_data = [
  {
    id: 0,
    avatar_url:userPic1,
    user_name: "Sarah, Event Attendee",
    review:
      "“I never realized how easy it was to meet people who love the same things I do. I’ve joined three events this month alone – all through My...!”",
  },
  {
    id: 1,
    avatar_url:userPic2,
    user_name: "Lisa, Community User",
    review:
      "“From catching up with friends to discovering new groups, My... has become my go-to app for everything social.”",
  },
  {
    id: 2,
    avatar_url:userPic3,
    user_name: "Maria, Artist & Event Host",
    review:
      "“At first, I joined for the events, but now I’m using My... to sell my art and connect with local creators. It’s so much more than just another app.”",
  },
];

const Home = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [openIndex, setOpenIndex] = useState(null);

  const scroll = (direction) => {
    if (!scrollRef.current) return;

    const scrollAmount = 76; // 64px + 12px gap

    if (direction === "left") {
      scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else if (direction === "right") {
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };
    useEffect(() => {
      // Check if the user has already visited the page
      const hasVisited = sessionStorage.getItem("hasVisited");
      const redirectAndroidURL = process.env.REACT_APP_HOST_URL.includes("my-prod") ? "https://play.google.com/store/apps/details?id=com.stefan23.Ghabryal.v1" :`https://play.google.com/apps/test/RQzPbBDBjUQ/ahAO29uNTz0IZAfewr7yzsv6-rU2zOLnJQ7uw_VdKaaEfY_2EFtcm5sy584OVEEtVPNUQe0i2AOSsPISXOnpKLYIoq`;
      const redirectIOSURL = process.env.REACT_APP_HOST_URL.includes("my-prod") ?  "https://apps.apple.com/us/app/my/id1603899001" :  "https://apps.apple.com/us/app/my/id1603899001";
      if (!hasVisited) {
        var deep_link_url = window.location.search;
        var now = new Date().valueOf();
  
        if (deep_link_url !== "") {
          // Variable will check if the app is installed or not
          var change = false;
        
          setTimeout(() => {
            if (!change) {
              var redirectUrl = "";
              if (isAndroid) {
                redirectUrl = redirectAndroidURL
              } else if (isIOS) {
                redirectUrl = redirectIOSURL;
              }
              window.location = redirectUrl;
            }
          }, 3000);
  
          window.location = "myapp://" + deep_link_url;
  
          // Handle event to check if the app is installed or not
          window.onblur = function () {
            change = true;
          };
          window.onfocus = function () {
            change = false;
          };
        } else {
          if (
            (isAndroid || isIOS) &&
            window.confirm("Would you like to visit the App Store?")
          ) {
            setTimeout(function () {
              if (new Date().valueOf() - now > 100) {
                if (isAndroid) {
                  window.location.href = redirectAndroidURL
                } else if (isIOS) {
                  window.location.href = redirectIOSURL;
                }
              }
            }, 500);
          }
        }
        // Mark the user as having visited the page
        sessionStorage.setItem("hasVisited", true);
      }
    }, []);

  return (
    <div className="home-container">
      {/* fluid container for edge-to-edge layout, no default padding */}
      <Container
        fluid
        // className="p-0"
        // style={{ paddingLeft: "3%", paddingRight: "3%" }}
      >
        {/* ==================== Hero Section (Content + Image) ==================== */}
        <section className="hero-section d-flex align-items-center global_padding">
          {/* g-0 removes gutter, w-100 makes row take full width, flex-grow-1 for hero height */}
          <Row className="g-0 w-100 flex-grow-1">
            {/* Left Column: Hero Content (Badge, Text, Buttons) and Trusted Partners */}
            {/* order-1/2 for mobile reordering, d-flex flex-column justify-content-center for vertical alignment */}
            <Col
              xl={5}
              lg={5}
              md={12}
              sm={12}
              xs={12}
              className="hero-content-col order-1 order-lg-1 d-flex flex-column justify-content-center"
              style={{ minWidth: "auto" }}
            >
              {/* Community Hub Badge - Placed inline with content, styled with CSS */}
              <div className="community-hub-badge-inline">
                {/* Requires Bootstrap Icons: npm install bootstrap-icons */}
                <label
                  style={{
                    padding: " 8px",
                    borderRadius: "16px",
                    background: "linear-gradient(to bottom, #DADADA, #FFFFFF)",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px", // optional spacing between icon and text
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    border: "solid 1px #DADADA",
                  }}
                >
                  <FaUserFriends size={18} color={netural400} /> The Community
                  Hub
                </label>
              </div>

              <div>
                {/* Main Heading */}
                <h1>Discover, Connect, and Share with My...</h1>

                {/* Descriptive Paragraph */}
                <p className="hero-description">
                  The app where you chat, shop, and share, whether it's finding
                  your people, discovering events, buying or selling something
                  unique.
                </p>

                {/* Action Buttons and Link */}
                <div className="hero-actions">
                  <Button variant="warning" className="download-button">
                    Download My... App
                  </Button>
                  <a href="#learn-more" className="learn-more-link">
                    Learn more <IoChevronDown color={primaryOrange} size={20} />
                  </a>
                </div>
              </div>

              {/* Trusted Partners Section - Below hero content, left-aligned */}
              <div className="trusted-partners-area">
                <p className="trusted-partners-text">
                  Trusted business partners:
                </p>
                <div className="partners-logos d-flex flex-wrap justify-content-start align-items-center">
                  <div className="partner-logo-item">
                    <img
                      src={royalCaninLogo}
                      alt="Royal Canin Logo"
                      className="img-fluid"
                    />
                  </div>
                  <div className="partner-logo-item">
                    <img
                      src={purinaLogo}
                      alt="Purina Logo"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>

            {/* Right Column: Hero Image */}
            <Col
              xl={7}
              lg={7}
              md={12}
              sm={12}
              xs={12}
              className="hero-image-col order-2 order-lg-2 d-flex justify-content-center align-items-center"
            >
              {/* Desktop Image - Visible only on large screens and up */}
              <img
                src={heroImageDesktop}
                alt="App screenshots with people"
                className="img-fluid desktop-hero-img d-none d-lg-block"
              />
              {/* Mobile Image - Visible only on screens smaller than large */}
              <img
                src={heroImageMobile}
                alt="App screenshots mobile"
                className="img-fluid mobile-hero-img d-lg-none"
              />
            </Col>
          </Row>
        </section>

        <section
          className="container my-5 py-4 global_padding"
          style={{
            borderTop: "1px solid #e0e0e0",
            borderBottom: "1px solid #e0e0e0",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <div className="d-md-none d-flex align-items-center">
            <button
              className="btn btn-outline-secondary btn-sm me-2"
              onClick={() => scroll("left")}
            >
              <IoChevronBack color={neturalBlack} size={20} />
            </button>

            <div
              ref={scrollRef}
              className="d-flex overflow-auto"
              style={{
                gap: "12px",
              }}
            >
              {categories.map((cat, idx) => (
                <div
                  key={idx}
                  className="text-center flex-shrink-0"
                  style={{
                    width: "64px",
                    height: "52px",
                  }}
                >
                  <img
                    src={cat.image}
                    alt={cat.name}
                    style={{
                      width: "24px",
                      height: "24px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                  <div style={{ fontSize: "12px", marginTop: "4px" }}>
                    {cat.name}
                  </div>
                </div>
              ))}
            </div>

            <button
              className="btn btn-outline-secondary btn-sm ms-2"
              onClick={() => scroll("right")}
            >
              <IoChevronForward color={neturalBlack} size={20} />
            </button>
          </div>

          {/* Desktop view: All categories in one row */}
          <div
            className="d-none d-md-flex mt-3"
            style={{ justifyContent: "space-between" }} // add padding here too
          >
            {categories.map((cat, idx) => (
              <div
                key={idx}
                className="text-center"
                style={{
                  width: "111px",
                  height: "96px",
                }}
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  style={{
                    width: "48px",
                    height: "48px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <div style={{ fontSize: "14px", marginTop: "4px" }}>
                  {cat.name}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section
          id="learn-more"
          className="presentation-container container my-5 global_padding"
        >
          <div
            className="row"
            style={{ minHeight: "400px", paddingTop:"3%"}}
          >
            {/* Left Column: List Items */}
            <div className="col-md-6 left-content">
              {/* Community Hub Badge - Placed inline with content, styled with CSS */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px", // space between label and image
                }}
              >
                {/* Requires Bootstrap Icons: npm install bootstrap-icons */}
                <label
                  style={{
                    padding: " 8px",
                    borderRadius: "16px",
                    background: "linear-gradient(to bottom, #DADADA, #FFFFFF)",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px", // optional spacing between icon and text
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    border: "solid 1px #DADADA",
                  }}
                >
                  <IoSettingsSharp size={18} color={netural400} /> Features &
                  Benefits Hub
                </label>
                <img
                  src={features}
                  alt="Features"
                  // style={{ width: "40px", height: "40px" }}
                />
              </div>
              <h1
                style={{
                  fontWeight: "700",
                  fontSize: "2.5rem",
                }}
              >
                Explore Platform's Exciting Features
              </h1>

              <div className="subtitle-list">
                {sections.map((section, idx) => {
                  const isActive = idx === activeIndex;
                  return (
                    <div
                      key={idx}
                      onClick={() => setActiveIndex(isActive ? null : idx)}
                      className={`subtitle-block ${isActive ? "active" : ""}`}
                    >
                      <div className="subtitle-content">
                        <div
                          className={`left-border ${
                            isActive ? "selected" : ""
                          }`}
                        ></div>
                        <span className="icon">{section.icon(isActive)}</span>
                        <h5
                          style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            lineHeight: "32px",
                          }}
                        >
                          {section.title}
                        </h5>
                      </div>
                      {isActive && (
                        <label
                          className="expanded-body"
                          style={{ justifyContent: "start", marginLeft: "3%" }}
                        >
                          {section.body}
                        </label>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-6 right-content d-flex justify-content-center">
              <img
                src={
                  activeIndex !== null
                    ? sections[activeIndex].gif
                    : sections[0].gif
                }
                alt="Feature preview"
                className="responsive-gif"
              />
            </div>
          </div>
        </section>

        {/* ==================== About us section ==================== */}
        <section
          style={{
            backgroundImage: `
              linear-gradient(to bottom,rgba(255, 255, 255, 0.8), rgba(255, 247, 239, 0.8)),
              url(${about_us_background})
            `,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '400px', 
            width:"100%"
          }}
          className="future-section-placeholder py-5 text-center text-dark global_padding"
        >
          <div className="about-us-section">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px", // space between label and image
              }}
            >
              <label
                style={{
                  padding: "8px",
                  borderRadius: "16px",
                  background: "linear-gradient(to bottom, #DADADA, #FFFFFF)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  border: "solid 1px #DADADA",
                }}
              >
                <IoAlertCircle size={18} color={netural400} /> About us
              </label>
              <img
                src={about_us}
                alt="About us"
                // style={{ width: "40px", height: "40px" }}
              />
            </div>
            <h1 style={{ fontSize: "2.5rem", fontWeight: "700" }}>
              Who we are
            </h1>
            <label className="about-us-description">
              We proudly serve our local community and members, offering
              exclusive deals, discounts, and access to exciting events. From
              home essentials, household services to social gatherings,
              pet-friendly activities and more – creating endless ways to
              connect and share experiences.
            </label>
          </div>
          <div style={{ marginTop: "5%" }}>
            <img
              src={about_us_logo}
              alt="About us Logo"
              // style={{ width: "40px", height: "40px" }}
            />
          </div>
        </section>
        {/* ==================== Testimonials section ==================== */}
        <section
          style={{ backgroundColor: "white" }}
          className="future-section-placeholder py-5 text-center text-dark global_padding"
        >
          <div className="about-us-section">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px", // space between label and image
              }}
            >
              <label
                style={{
                  padding: "8px",
                  borderRadius: "16px",
                  background: "linear-gradient(to bottom, #DADADA, #FFFFFF)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  border: "solid 1px #DADADA",
                }}
              >
                <IoChatbubbles size={18} color={netural400} /> Testimonials
              </label>
              <img
                src={testimonials}
                alt="Testimonials"
                // style={{ width: "40px", height: "40px" }}
              />
            </div>
            <h1 style={{ fontSize: "2.5rem", fontWeight: "700" }}>
              What people say about us
            </h1>
            <p className="about-us-description">
              My... enables people to find what they’re looking for.
            </p>
          </div>
          <Row style={{ marginTop: "5%", width: "100%" }}>
            {testimonials_data.map((userInfo, index) => (
              <Col xl={4} lg={4} md={4} sm={12} xs={12} key={index}>
                <Card
                  style={{
                    padding: "4%",
                    borderRadius: "12px",
                    border: "solid 1px #E6F6E6",
                    boxShadow: "0px 0px 8px 0px #F2F2F2 inset",
                    background:
                      "linear-gradient(200deg, #FFF 13.36%, #F0F0F0 199.48%), rgba(255, 255, 255, 0.99)",
                  }}
                >
                  <p style={{ width: "95%", border: "solid 0px #fff" }}>
                    {userInfo.review}
                  </p>
                  <div
                    style={{
                      borderTop: "solid 1px #E6F6E6",
                      marginTop: "5%",
                      marginBottom: "5%",
                    }}
                  ></div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginLeft: "2%",
                      marginRight: "2%",
                    }}
                  >
                    <img
                      src={userInfo.avatar_url}
                      alt="Testimonials"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                      }}
                    />
                    <label
                      style={{
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                        alignItems: "center",
                        display: "flex",
                        marginLeft: "3%",
                      }}
                    >
                      {userInfo.user_name}
                    </label>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* ==================== FAQ section ==================== */}
        <section
          style={{ backgroundColor: "white" }}
          className="future-section-placeholder py-5 text-center text-dark global_padding"
        >
          <Row style={{ width: "100%" }}>
            <Col
              xl={5}
              lg={5}
              md={12}
              sm={12}
              xs={12}
              style={{ textAlign: "start" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px", // space between label and image
                }}
              >
                <label
                  style={{
                    padding: "8px",
                    borderRadius: "16px",
                    background: "linear-gradient(to bottom, #DADADA, #FFFFFF)",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    border: "solid 1px #DADADA",
                  }}
                >
                  <IoHelpCircle size={18} color={netural400} /> FAQs
                </label>
                <img
                  src={faq}
                  alt="FAQ"
                  // style={{ width: "40px", height: "40px" }}
                />
              </div>
              <label style={{ fontSize: "2.5rem", fontWeight: "700" }}>
                Have Questions? We’ve Got Answers.
              </label>
              <label
                style={{
                  fontSize: "18px",
                  fontWeight: "400",
                  lineHeight: "32px",
                }}
              >
                From setting up your profile, connecting with your community to
                making your first sale – here’s what you need to know.
              </label>
            </Col>
            <Col xl={1} lg={1}></Col>
            <Col xl={5} lg={5} md={12} sm={12} xs={12}>
              {faqData.map((faqInfo, index) => (
                <Collapsible
                  key={index}
                  // className="faq_question_style"
                  open={openIndex === index}
                  onOpening={() => setOpenIndex(index)}
                  onClosing={() => setOpenIndex(null)}
                  triggerStyle={{
                    fontSize: "16px",
                    fontWeight: "500",
                    width: "100%",
                    display: "flex",
                    padding: "3%",
                    border: "solid 1px #F2F2F2",
                    borderRadius:
                      openIndex === index ? "12px 12px 0 0" : "12px",
                    background:
                      "linear-gradient(200deg, #FFF 13.36%, #F0F0F0 199.48%), rgba(255, 255, 255, 0.99)",
                    marginTop: index !== 0 ? "3%" : "0px",
                  }}
                  trigger={
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        textAlign: "start",
                        alignItems: "center",
                      }}
                    >
                      <CustomLabel
                        style={{
                          width: "98%",
                          fontSize: "18px",
                          fontWeight: "600",
                        }}
                      >
                        {faqInfo.question}
                      </CustomLabel>
                      <IoChevronDownOutline />
                    </div>
                  }
                  triggerWhenOpen={
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        textAlign: "start",
                      }}
                    >
                      <CustomLabel
                        style={{
                          width: "98%",
                          fontSize: "18px",
                          fontWeight: "600",
                        }}
                      >
                        {faqInfo.question}
                      </CustomLabel>
                      <IoChevronUpOutline />
                    </div>
                  }
                >
                  <div
                    style={{
                      border: "solid 1px #F2F2F2",
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                      background:
                        "linear-gradient(200deg, #FFF 13.36%, #F0F0F0 199.48%), rgba(255, 255, 255, 0.99)",
                      marginTop: "-1%",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        padding: "3%",
                      }}
                    >
                      {faqInfo.answer}
                    </label>
                  </div>
                </Collapsible>
              ))}
            </Col>
          </Row>
        </section>

        <AppDownloadSection />
      </Container>
    </div>
  );
};

export default Home;